import { useState, useRef } from 'react';

/**
 * handles the listeners and the cleanup of mouseover elements
 * const [hoverRef, isHovered] = useHover();
 *
 */

export function useHover() {
  const [value, setValue] = useState(false);

  const timeoutRef = useRef();

  const onMouseOver = () => {
    clearTimeout(timeoutRef.current);
    setValue(true);
  };
  const onMouseOut = () => {
    // Without this, the onhover in theattachmentCloseButton will flicker,
    //  TODO/ fixme: on hover of the parent elemet, the child element is rendered, which triggers the onMouseOut of the parent and creates a loop,
    //  This timeout solves the problem
    timeoutRef.current = setTimeout(() => setValue(false), 80);
  };

  return [{ onMouseOver, onMouseOut }, value];
}
